import { render } from "./PageCookingList.vue?vue&type=template&id=2f8fb633&scoped=true"
import script from "./PageCookingList.vue?vue&type=script&lang=js"
export * from "./PageCookingList.vue?vue&type=script&lang=js"

import "./PageCookingList.vue?vue&type=style&index=0&id=2f8fb633&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8fb633"]])

export default __exports__